const TableActionsContainerStyle = `
  grid-auto-flow: column;
`;

export default TableActionsContainerStyle;
